import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import toast from 'react-hot-toast';

import { registerSchema, type RegisterInput } from '@realvisor/schemas';
import { useAuth } from '@/contexts/AuthContext';
import { Button, Input } from '@realvisor/ui';

export default function Register() {
  const [isLoading, setIsLoading] = useState(false);
  const { signUp } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterInput>({
    resolver: zodResolver(registerSchema),
  });

  const onSubmit = async (data: RegisterInput) => {
    setIsLoading(true);

    try {
      await signUp(data.email, data.password, data.name);
      toast.success('Účet vytvořen! Zkontrolujte svůj e-mail.');
      navigate('/login');
    } catch {
      toast.error('Nepodařilo se vytvořit účet');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Registrace</h2>
        <p className="mt-2 text-sm text-gray-600">
          Máte již účet?{' '}
          <Link to="/login" className="font-medium text-primary-600 hover:text-primary-500">
            Přihlaste se
          </Link>
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6">
        <Input
          label="Jméno a příjmení"
          type="text"
          autoComplete="name"
          error={errors.name?.message}
          {...register('name')}
        />

        <Input
          label="E-mail"
          type="email"
          autoComplete="email"
          error={errors.email?.message}
          {...register('email')}
        />

        <Input
          label="Heslo"
          type="password"
          autoComplete="new-password"
          hint="Minimálně 8 znaků"
          error={errors.password?.message}
          {...register('password')}
        />

        <Button type="submit" className="w-full" isLoading={isLoading}>
          Vytvořit účet
        </Button>
      </form>
    </>
  );
}
